import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const heights = {
  page: '50vh',
  section: 220,
  inline: 120,
};

/**
 * Shared loading UI for pages, sections, and modals.
 * variant: 'page' | 'section' | 'inline'
 */
const PageLoader = ({ message = 'Loading...', variant = 'page', minHeight, size }) => {
  const spinnerSize = size ?? (variant === 'inline' ? 28 : variant === 'section' ? 32 : 40);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        width: '100%',
        minHeight: minHeight ?? heights[variant] ?? heights.page,
        py: variant === 'page' ? 4 : 2,
      }}
    >
      <CircularProgress size={spinnerSize} thickness={4} color="primary" />
      {message && (
        <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default PageLoader;
